<template>
  <admin-layout title="Recrutadores" menu="Recrutadores">
    <div class="row">
      <div class="col-lg-12">
        <div class="block_info_white p-2">
          <div class="row">
            <div class="col-lg-12">
              <h3 class="color-black">RECRUTADORES</h3>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3 col-xs-12">
              <div
                class="form-group mb-0 has-search d-flex justify-content-end"
                style="margin-left: -3px"
              >
                <div>
                  <span
                    class="color-black fa fa-search ml-2 mt-2 mr-3 form-control-feedback"
                  ></span>
                </div>
                <input
                  type="text"
                  v-model="search"
                  @change="searchRecruiter"
                  v-on:keyup.enter="searchRecruiter"
                  class="form-control no_border"
                />
              </div>
            </div>

            <div class="col-lg-6">
              <select
                @change="searchRecruiter"
                v-model="status"
                class="form-control col-xl-4"
              >
                <option
                  v-for="status in statusRecruiter"
                  :key="status.value"
                  :value="status.value"
                >
                  {{ status.text }}
                </option>
              </select>
            </div>
            <div class="col-lg-3 col-xs-12">
              <inertia-link href="/recruiters/teams/new">
                <button class="btn-new-job" style="height: 38px; width: 95%">
                  CRIAR RECRUTADOR
                </button>
              </inertia-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-lg-12">
        <table class="table_jovool">
          <thead class="headerTable">
            <tr>
              <td class="center">
                NOME DO RECRUTADOR(A)
                <OrderTable field="name" entity="Recruiter" />
              </td>
              <td class="center">
                DATA DE CRIAÇÃO
                <OrderTable
                  field="created_at"
                  entity="Recruiter"
                  pre_order="desc"
                />
              </td>
              <td class="center">
                RECRUTADOR(A) RESPONSÁVEL
                <OrderTable entity="Recruiter" field="name" />
              </td>
              <td class="center">EDITAR</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="recruiter in recruiters" :key="recruiter.id">
              <td class="center color-grey">{{ recruiter.name }}</td>
              <td class="center color-grey">
                {{ recruiter.created_at | moment("D/MM/Y") }}
              </td>
              <td class="center color-grey">
                {{ recruiter.admin_name || "Administrador" }}
              </td>
              <td class="center">
                <inertia-link :href="`/recruiters/teams/${recruiter.id}/edit`">
                  <span class="pointer color-grey" title="Editar live">
                    <i class="fa fa-pencil-alt"></i>
                  </span>
                </inertia-link>
              </td>
            </tr>
          </tbody>
        </table>
        <v-pagination
          v-model="currentPage"
          :page-count="pageCount"
          class="justify-content-center"
          :class="firstLoad ? 'd-none' : 'd-flex'"
          :classes="bootstrapPaginationClasses"
        ></v-pagination>
      </div>
    </div>
  </admin-layout>
</template>
<script>
import OrderTable from "components/OrderTable.vue";
import vPagination from "vue-plain-pagination";
export default {
  components: { OrderTable, vPagination },
  props: ["block"],
  mounted() {
    if (this.block) {
      this.$toast.error(
        "Você ja atingiu a cota máxima de usuários nessa conta"
      );
    }
    eventBus.$on("orderColumnRecruiter", (fields) => {
      this.field = fields.field;
      this.order = fields.order;
      this.searchRecruiter();
    });
    this.searchRecruiter();
  },
  data() {
    return {
      search: "",
      order: "",
      field: "",
      firstLoad: true,
      pageCount: 1,
      currentPage: 1,
      total_recruiters: 0,
      recruiters: [],
      statusRecruiter: [
        { text: "Desativado", value: 0 },
        { text: "Ativo", value: 1 },
        { text: "Bloqueado", value: 2 },
      ],
      status: 1,
      bootstrapPaginationClasses: {
        ul: "pagination",
        li: "page-item",
        liActive: "active",
        liDisable: "disabled",
        button: "page-link",
      },
    };
  },
  watch: {
    currentPage: function () {
      this.searchRecruiter();
    },
  },
  methods: {
    changeStatus(status) {
      this.searchRecruiter();
    },
    searchRecruiter() {
      let params = {};

      params["search"] = "*";
      if (this.search != "") params["search"] = this.search;
      if (this.field != "") {
        params["order"] = {};
        params["order"][this.field] = this.order;
      } else {
        params["order"] = {};
        params["order"]["created_at"] = "desc";
      }

      if (this.status !== "") {
        params["status"] = this.status;
      }

      axios
        .get(`/recruiters/teams/search/${this.currentPage}`, { params: params })
        .then((response) => {
          this.recruiters = response.data.recruiters;
          this.total_recruiters = response.data.total_recruiters;
          this.pageCount = Math.ceil(this.total_recruiters / 10);
          this.firstLoad = false;
          return;
        });
    },
  },
};
</script>
